import { normalize_text } from './view_case_details_helpers';
import { format_file_size } from './view_case_details_record_document_helpers';

const TIME_ENTRY_EVIDENCE_EXTENSIONS = [
  'pdf', 'doc', 'docx',
  'jpg', 'jpeg', 'png', 'heic',
  'mp4', 'mov', 'avi',
  'mp3', 'wav', 'm4a', 'aac',
];
const TIME_ENTRY_EVIDENCE_FORMATS_LABEL = 'PDF, DOC, DOCX, JPG, JPEG, PNG, HEIC, MP4, MOV, AVI, MP3, WAV, M4A, AAC';
const TIME_ENTRY_EVIDENCE_ACCEPT = [
  ...TIME_ENTRY_EVIDENCE_EXTENSIONS.map((extension) => `.${extension}`),
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/mp4',
  'audio/aac',
].join(',');
const DEFAULT_TIME_ENTRY_EVIDENCE_MAX_MB = 25;

export function time_entry_evidence_accept() {
  return TIME_ENTRY_EVIDENCE_ACCEPT;
}

export function time_entry_supported_formats_label() {
  return TIME_ENTRY_EVIDENCE_FORMATS_LABEL;
}

export function time_entry_max_file_size_bytes() {
  const explicit_bytes = Number(process.env.VUE_APP_TIME_ENTRY_EVIDENCE_MAX_BYTES);
  if (Number.isFinite(explicit_bytes) && explicit_bytes > 0) {
    return explicit_bytes;
  }

  const configured_mb = Number(process.env.VUE_APP_TIME_ENTRY_EVIDENCE_MAX_MB);
  const max_mb = Number.isFinite(configured_mb) && configured_mb > 0
    ? configured_mb
    : DEFAULT_TIME_ENTRY_EVIDENCE_MAX_MB;
  return max_mb * 1024 * 1024;
}

export function time_entry_max_file_size_label() {
  return format_file_size(time_entry_max_file_size_bytes());
}

export function time_entry_evidence_required() {
  return String(process.env.VUE_APP_TIME_ENTRY_EVIDENCE_REQUIRED || '').toLowerCase() === 'true';
}

export function time_entry_file_validation_message(file, seen_keys = new Set()) {
  if (!file) {
    return 'No file was selected for upload.';
  }

  const extension = file_extension(file).toLowerCase();
  if (!TIME_ENTRY_EVIDENCE_EXTENSIONS.includes(extension)) {
    return `${file.name || 'This file'} is not supported. Upload ${TIME_ENTRY_EVIDENCE_FORMATS_LABEL}.`;
  }

  const max_size = time_entry_max_file_size_bytes();
  if (file.size > max_size) {
    return `${file.name || 'This file'} is ${format_file_size(file.size)}. Maximum permitted file size is ${format_file_size(max_size)}.`;
  }

  if (seen_keys.has(file_key(file))) {
    return `${file.name || 'This file'} is already attached to this time entry.`;
  }

  return '';
}

export function time_entry_attachment(file) {
  const attachment = {};
  attachment.key = file_key(file);
  attachment.file = file;
  attachment.name = file?.name || 'Evidence';
  attachment.file_type = file_extension(file).toUpperCase();
  attachment.size = file?.size || 0;
  attachment.size_label = format_file_size(file?.size);
  attachment.status = 'Ready to upload';
  return attachment;
}

export function file_key(file = {}) {
  return [
    normalize_text(file?.name).toLowerCase(),
    file?.size || 0,
    file?.lastModified || 0,
  ].join(':');
}

export function file_extension(file = {}) {
  const name = normalize_text(file?.name);
  const extension = name.includes('.') ? name.split('.').pop() : '';
  return extension || normalize_text(file?.type).split('/').pop() || 'file';
}
